<template>
  <label class="__checkbox" :id="id" :class="(valueInput == false) ? 'bat_luc' : ''">
    <input
      type="checkbox"
      :value="value"
      v-model="valueInput"
      @change="changeCheckbox($event)"
      :disabled="disabled"
    />
    <span :class="classCheckBox()" />
  </label>
</template>

<script>
export default {
  props: {
    getVmodel: {
      type: [Boolean, Array, String],
      default: "",
    },
    value: {
      type: [Boolean, Array, String, Object],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "checkmark",
    },
    id: {
      type: String,
      default: "",
    },
  },

  model: {
    prop: "getVmodel",
    event: "sendToVmodel",
  },

  methods: {
    classCheckBox() {
      if (this.type === "radio") {
        return `${this.disabled ? `__${this.type}_disabled` : "__radio"}`;
      } else {
        if (this.getVmodel != "ORTHER") {
          return `${this.disabled ? `__${this.type}_disabled` : "__checkmark"}`;
        } else {
          return "__checkmark-minus";
        }
      }
    },

    changeCheckbox(value) {
      this.$emit("change", value);
      this.$emit("click", value);
    },

    checkGetVModel(value) {
      const index = this.getVmodel.findIndex(
        (e) => JSON.stringify(e) === JSON.stringify(value)
      );
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    },
  },

  computed: {
    valueInput: {
      get: function () {
        if (this.getVmodel === true) {
          return true;
        } else if (this.getVmodel === false) {
          return false;
        } else if (this.getVmodel == "TRUE") {
          return true;
        } else if (this.getVmodel == "FALSE") {
          return false;
        } else if (this.getVmodel == "ORTHER") {
          return true;
        } else if (
          typeof this.getVmodel == "object" &&
          this.getVmodel.length > 0 &&
          this.checkGetVModel(this.value)
        ) {
          return true;
        } else if (
          typeof this.getVmodel == "object" &&
          this.getVmodel.length == 0 &&
          !this.checkGetVModel(this.value)
        ) {
          return false;
        }
      },

      set: function (value) {
        if (
          typeof this.getVmodel == "object" &&
          !this.checkGetVModel(this.value)
        ) {
          this.getVmodel.push(this.value);
          this.$emit("sendToVmodel", this.getVmodel);
        } else if (
          typeof this.getVmodel == "object" &&
          this.checkGetVModel(this.value)
        ) {
          const index = this.getVmodel.findIndex(
            (e) => JSON.stringify(e) === JSON.stringify(this.value)
          );
          this.getVmodel.splice(index, 1);
          this.$emit("sendToVmodel", this.getVmodel);
        } else {
          this.$emit("sendToVmodel", value);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.__checkbox {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 15px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
}

.__checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #fff;
  border: 1px solid #ccc;
}

.__checkbox:hover input ~ .__checkmark {
  background-color: #e7e7e7;
}

.__checkbox input:checked ~ .__checkmark {
  border: 1px solid #007aff;
}

.__checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.__checkbox input:checked ~ .__checkmark:after {
  display: block;
}

.bat_luc .__checkmark:after {
  border: none !important
}
.bat_luc input:checked ~ .__checkmark {
  border: 1px solid #ccc;
}
.__checkbox .__checkmark:after {
  left: 4px;
  top: 1px;
  width: 6px;
  height: 10px;
  border: solid #007aff;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

// =============== CHECKMARK-MINUS =================
// =================================================

.__checkmark-minus {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #fff;
  border: 1px solid #ccc;
}

.__checkbox:hover input ~ .__checkmark-minus {
  background-color: #e7e7e7;
}

.__checkbox input:checked ~ .__checkmark-minus {
  border: 1px solid #007aff;
}

.__checkmark-minus:after {
  content: "";
  position: absolute;
  display: none;
}

.__checkbox input:checked ~ .__checkmark-minus:after {
  display: block;
}

.__checkbox .__checkmark-minus:after {
  left: 2px;
  top: 6px;
  width: 9px;
  border: solid #007aff;
  border-width: 2px 0 0 0;
}

// =============== CHECKMARK-DISABLED =================
// ====================================================

.__checkmark_disabled {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #f2f3f4;
  border: 1px solid #ccc;
}

.__checkbox:hover input ~ .__checkmark_disabled {
  background-color: #e7e7e7;
}

.__checkbox input:checked ~ .__checkmark_disabled {
  border: 1px solid #ddd;
}

.__checkmark_disabled:after {
  content: "";
  position: absolute;
  display: none;
}

.__checkbox input:checked ~ .__checkmark_disabled:after {
  display: block;
}

.__checkbox .__checkmark_disabled:after {
  left: 4px;
  top: 1px;
  width: 6px;
  height: 10px;
  border: solid #8b95a5;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

// =================== RADI0 ==========================
// ====================================================

.__radio_disabled {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #f2f3f4;
  border: 2px solid #e7e7e7;
  border-radius: 50%;

  &:after {
    content: "";
    position: absolute;
    display: none;
    border-radius: 50%;
    left: 20%;
    right: 20%;
    top: 20%;
    background: #bdc1c5;
    bottom: 20%;
  }
}

.__checkbox {
  &:hover {
    input ~ .__radio_disabled {
      background-color: #e7e7e7;
    }
  }

  input {
    &:checked ~ .__radio_disabled {
      border: 2px solid #bdc1c5;
      border-radius: 50%;

      &:after {
        display: block;
      }
    }
  }
}

.__radio {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  // background-color: #f2f3f4;
  background: #fff;
  border-radius: 50%;
  border: 2px solid #bdc1c5;

  &:after {
    content: "";
    position: absolute;
    display: none;
    border-radius: 50%;
    left: 20%;
    right: 20%;
    top: 20%;
    background: #3e69f6;
    bottom: 20%;
  }
}

.__checkbox {
  &:hover {
    input ~ .__radio {
      background-color: #e7e7e7;
      border-radius: 50%;
    }
  }

  input {
    &:checked ~ .__radio {
      border: 2px solid #3e69f6;
      border-radius: 50%;

      &:after {
        display: block;
      }
    }
  }
}
</style>
